export const findProfileTemplateById = (id, array) => {
  if (Array.isArray(array) && array.length > 0) {
    const response = array?.find((arrayItem) => arrayItem._id === id);
    return response;
  }
  return null;
};
